import React, { useEffect, useRef, useState } from 'react';
import time from 'utils/time';
import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
dayjs.extend(advancedFormat);

function AdditionalRecipientInfo({ isLoading, info, status, emailAddress }) {
  const getActionName = (action) => {
    switch (action) {
      case 'Click':
        return 'Clicked';
      case 'Open':
        return 'Opened';
      case 'Delivery':
        return 'Delivered';
      case 'Send':
        return emailAddress ? `Sent to ${emailAddress}` : 'Sent';
      default:
        return action;
    }
  };
  const AdditionalInfoRow = ({ data }) => {
    const actionText = getActionName(data.type);
    const isSendRow = data.type === 'Send';
    const textRef = useRef(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useEffect(() => {
      if (isSendRow && textRef.current) {
        setIsTruncated(textRef.current.scrollWidth > textRef.current.clientWidth);
      }
    }, [isSendRow, actionText]);

    return (
      <div className='additional-recipient-info-row'>
        <div className='additional-recipient-info-row-first-cell paragraph-p2'>
          {isSendRow ? (
            <span
              ref={textRef}
              className='d-block text-truncate'
              data-tooltip-content={isTruncated ? actionText : undefined}
              data-tooltip-id={isTruncated ? 'general-tooltip' : undefined}
            >
              {actionText}
            </span>
          ) : (
            actionText
          )}
          {data.clickLink && <span className='email-performance-link'>{data.clickLink}</span>}
        </div>
        <div className='additional-recipient-info-row-second-cell paragraph-p3'>
          <span>{time(data.eventDateTime).format('MMMM Do, YYYY')}</span>
          <span>&nbsp;at {time(data.eventDateTime).format('HH:mm:ss')}</span>
        </div>
      </div>
    );
  };

  const notSentText =
    status === 'Cancelled' || status === undefined
      ? emailAddress
        ? `Email not sent, used ${emailAddress}`
        : 'Email not sent'
      : 'No events';

  return (
    <>
      {isLoading ? (
        <div className='additional-recipient-info-loading-container'>
          <i className='fas fa-spinner fa-spin'></i>
        </div>
      ) : (
        <>
          {info?.length > 0 ? (
            <>
              {info.map((data, index) => (
                <AdditionalInfoRow key={`${index}-${data.type}`} data={data} />
              ))}
            </>
          ) : (
            <div className='additional-recipient-info-loading-container paragraph-p2'>
              <span style={{ color: 'rgba(0, 18, 43, 0.45)' }}>{notSentText}</span>
            </div>
          )}
        </>
      )}
    </>
  );
}
export default AdditionalRecipientInfo;
